__turbopack_context__.v({
  "dropdown": "index-module__etNnPq__dropdown" + " " + __turbopack_context__.i(23484)["dropdown"],
  "error": "index-module__etNnPq__error" + " " + __turbopack_context__.i(367887)["error"],
  "input": "index-module__etNnPq__input" + " " + __turbopack_context__.i(367887)["input"],
  "label": "index-module__etNnPq__label" + " " + __turbopack_context__.i(367887)["label"],
  "option": "index-module__etNnPq__option" + " " + __turbopack_context__.i(23484)["option"],
  "root": "index-module__etNnPq__root" + " " + __turbopack_context__.i(367887)["root"],
});
